import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function EmbededWebview() {
  const location = useLocation();
  const [iframeProps, setIframeProps] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const type = params.get("type");
    const action = params.get("action");
    const embedToken = params.get("embedToken");

    if (type === "domo" && action && embedToken) {
      const doc = `
        <!DOCTYPE html>
        <html>
          <body>
            <form id="form" action="${action}" method="post">
              <input type="hidden" name="embedToken" value="${embedToken}" />
            </form>
            <script>
              document.getElementById("form").submit();
              window.addEventListener('scroll', function () {
                window.parent.postMessage({ scrollY: window.scrollY }, '*');
              });
            </script>
          </body>
        </html>
      `;
      setIframeProps({ srcDoc: doc });
    } else if (["metabase", "quicksight"]?.includes(type) && action) {
      setIframeProps({ src: action });
    }
  }, [location.search]);

  return (
    <iframe
      id="iframe"
      title="page-embed"
      width="100%"
      height="100%"
      {...iframeProps}
    />
  );
}
